/**
 * Высота header для mobile
 * Значение должно быть синхронизировано с css переменной --header-height из custom.scss
 * */
export const APP_HEADER_HEIGHT = 60
/**
 * Высота header для desktop
 * Значение должно быть синхронизировано с css переменной --header-height из custom.scss
 * */
export const APP_HEADER_HEIGHT_DESKTOP = 76

export const COOKIE_BANNER_HEIGHT = 64
